import script from "./Krediflow-Workflow.vue?vue&type=script&setup=true&lang=js"
export * from "./Krediflow-Workflow.vue?vue&type=script&setup=true&lang=js"

import "./Krediflow-Workflow.vue?vue&type=style&index=0&id=1b6c9f66&lang=scss&scoped=true"
import "./Krediflow-Workflow.vue?vue&type=style&index=1&id=1b6c9f66&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b6c9f66"]])

export default __exports__